import insights from 'search-insights';
import React, {useEffect} from 'react';
import {Box, ChakraProvider, useMediaQuery, useToast} from '@chakra-ui/react';
import {Header} from './Comp/ui/headers/Header';
import {Footer} from './Comp/ui/footers/Footer';
import {Headermobile} from './Comp/ui/headers/Headermobile';
import {identify, init} from "@chamaeleonidae/chmln";
import Content from "./Comp/Content.js";
import {useQuery} from "react-query";
import {laravelAxios} from "./Comp/apiClients/laravelClient";
import {setAllUserInfo, setCurrentBranchID, logoutUser} from "./store/features/UserSlice";
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";
import {scrollToTop} from "./Comp/utils";
import CryptoJS from 'crypto-js';
import AlgoliaEventManager from './services/AlgoliaEventManager';

function App() {
    const {
        isLoggedIn, currentDebtorId, currentBranchId, allUserInfo
    } = useSelector(state => state.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const toast = useToast();
    const location = useLocation();
    const [isSmallScreen] = useMediaQuery("(max-width: 769px)");


    const {data: myInfo, refetch: refetchInfo} = useQuery('my-info', () => {
        // Only call if logged in
        if (!isLoggedIn) return Promise.reject('Not logged in');
        return laravelAxios.get('/me');
    }, {
        cacheTime: 0,
        enabled: !!isLoggedIn,
        select: (res) => res.data,
        onSuccess: (data) => {
            dispatch(setAllUserInfo({
                userInfo: data
            }));
            if (data.logoutuser && data.logoutuser === true) {
                navigate('/login');
                dispatch(logoutUser());
                return null;
            }
        }
    });

    const {refetch: refetchBranchInfo} = useQuery(['branch-info', myInfo?.branch_id], () => {
        if (!myInfo?.branch_id) return Promise.reject('No branch_id');
        return laravelAxios.get(`/branches/${myInfo.branch_id}`);
    }, {
        cacheTime: 0, refetchOnWindowFocus: false, enabled: !!myInfo?.branch_id, onSuccess: (res) => {
            if (res.data?.data) {
                dispatch(setCurrentBranchID({
                    currentBranchId: `${res.data?.data?.id}`, currentDebtorId: `${res.data?.data?.account_number}`
                }));
            }
        }
    })


    // useEffect(() => {
    //     const delay = 4000;
    //
    //     const timer = setTimeout(() => {
    //       if (allUserInfo !== null && location.pathname !== '/login') {
    //         const twentyFourHoursInMs = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
    //         const currentTime = new Date().getTime();
    //         const lastLoginTime = new Date(allUserInfo.lastlogin).getTime();
    //
    //         if (currentTime - lastLoginTime > twentyFourHoursInMs) {
    //           toast({title: "Your session is expired please login again", status: 'error', isClosable: true,duration: 2000});
    //           dispatch(logoutUser());
    //           navigate('/login');
    //         }
    //       }
    //     }, delay);
    //
    //     // Clear the timeout to avoid memory leaks
    //     return () => clearTimeout(timer);
    //   }, [allUserInfo, dispatch, navigate]);


    const {data: managerInfo} = useQuery(['manager-Info', currentDebtorId], () => {
        return laravelAxios.get(`/branchmanager/${currentDebtorId}`);
    }, {
        refetchOnWindowFocus: false, enabled: currentDebtorId !== '', select: (res) => {
            if (!res.data?.data) return null;
            const manager = res.data?.data[0];
            if (manager.length > 4) {
                const manager_phone = manager[6];
                const manager_email = manager[5];
                const manager_name = manager[4];
                const account_number = currentDebtorId;
                return {
                    manager_name, manager_phone, manager_email, account_number
                }
            }
            return null;
        },
    });

    const {refetch: updateOnChange} = useQuery(['update-manager', currentDebtorId, currentBranchId], () => {
        if (!managerInfo || !currentBranchId) return undefined;
        return laravelAxios.put(`branches/${currentBranchId}`, managerInfo);
    }, {
        cacheTime: 0, refetchOnWindowFocus: false, enabled: !!managerInfo && !!currentBranchId
    })

    useEffect(() => {
        updateOnChange();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [managerInfo]);

    useEffect(() => {
        if (isLoggedIn) { // Only refetch if logged in
            refetchInfo();
        }
        scrollToTop();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, isLoggedIn]);

    useEffect(() => {
        if (myInfo?.branch_id) { // Only refetch if branch_id is available
            refetchBranchInfo();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [myInfo?.branch_id]);

    // useEffect(() => {
    //     // Set a timeout to display a Chakra UI toast after 10 milliseconds
    //     const slowLoadTimeout = window.setTimeout(() => {
    //       toast({
    //         title: 'Slow internet speed',
    //         status: 'error', // You can adjust the status as needed
    //         isClosable: true,
    //       });
    //     }, 10000);
    //
    //     // Clear the timeout when the page finishes loading
    //     window.addEventListener('load', () => {
    //       window.clearTimeout(slowLoadTimeout);
    //     }, false);
    //
    //     // Clean up the event listener when the component unmounts
    //     return () => {
    //       window.removeEventListener('load');
    //       window.clearTimeout(slowLoadTimeout);
    //     };
    //   }, [toast]);

    function callChameleonApi() {
        if (isLoggedIn) {
            try{
                var _hsq = window._hsq = window._hsq || [];
                // console.log("Hubspot coming here");
                _hsq.push(["identify",{
                    email: allUserInfo?.email,
                    name: allUserInfo?.firstname + ' ' + allUserInfo?.lastname
                }])
            } catch (e) {
                console.log("Hubspot Error" + e)
            }

            try {
                const secret = 'VCNNvb0cmMTbhXNWfhiBU9wG8FR3-1OBmOk-DURGmSDvE9VaHVpu';
                const uid = allUserInfo?.id;
                const now = Math.floor(Date.now() / 1000);
                const uid_hash = [CryptoJS.HmacSHA256(`${uid}-${now}`, secret).toString(CryptoJS.enc.Hex), now].join('-');
                identify(uid, {
                    uid_hash: uid_hash,
                    created: allUserInfo?.created_at,
                    name: allUserInfo?.firstname + ' ' + allUserInfo?.lastname,
                    role: allUserInfo?.role?.title,
                    email: allUserInfo?.email,
                })
            } catch (e) {
                console.log("Chameleon Error" + e)
            }
        }
    }

    useEffect(() => {
        // getData();
        callChameleonApi();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        var _hsq = window._hsq = window._hsq || [];
        if (_hsq && isLoggedIn) {
            _hsq.push(['setPath', location.pathname]);
            _hsq.push(['trackPageView']);
        }
    }, [location,isLoggedIn]);

    useEffect(() => {
        (function(f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function() {
                n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = !0;
            n.version = '2.0';
            n.queue = [];
            t = b.createElement(e);
            t.async = !0;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
        })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

        if (typeof window.fbq !== 'undefined') {
            window.fbq('init', '721794539274506');
            window.fbq('track', 'PageView');
        }
    }, []);

    useEffect(() => {
        // Initialize Algolia user profile on app load
        if (isLoggedIn && allUserInfo?.id) {
            AlgoliaEventManager.setUserInfo({ isLoggedIn, allUserInfo });
            AlgoliaEventManager.setAlgoliaUserProfile();
        } else {
            // Set anonymous user profile
            AlgoliaEventManager.setUserInfo({ isLoggedIn: false, allUserInfo: null });
            AlgoliaEventManager.setAlgoliaUserProfile();
        }
    }, [isLoggedIn, allUserInfo?.id]);

    init('Sw0ojHygfPs30Z3WKHLGij5LxbKdhcbVfBm4CqttpoELwg-1OBmOk-DURGmSDvE9VaHVpu', {fastUrl: 'https://fast.chameleon.io/', forceOverride: true});
    return (<ChakraProvider>
        <Box className='full_width_container' textAlign="center">
            {isSmallScreen ? <Headermobile/> : <Header/>}
            <Content/>
            <Footer/>
        </Box>
    </ChakraProvider>);
}

export default App;
